// extracted by extract-css-chunks-webpack-plugin
module.exports = {"wrapper":"nav-module__wrapper--pWa07","nav":"nav-module__nav--dOWhr"};